export const checkDataIsEmpty = (value) => {
    return value === null || value === undefined || value === "";
 }